import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Icon, Spin } from "antd";
import { getCommissions } from "../../../actions/AffiliateActions";

class Commissions extends React.Component {
    state = {
        visible: false
    };

    componentDidMount() {
        const { affiliateId } = this.props.affiliates;

        this.props.dispatch(getCommissions(affiliateId));
    }

    componentDidUpdate(prevProps, prevState) {
        let { affiliateId } = this.props.affiliates;

        if (prevProps.affiliates.affiliateId !== affiliateId) {
            this.props.dispatch(getCommissions(affiliateId)).then((status) => {
            });
        }
    }

    render() {

        const { commissions } = this.props.affiliates;
        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

        return (
            <div className='ta--sub-account'>
                <h2 className='ta--main-header'>{this.props.intl.messages.commissions}</h2>
                <div className='ta--sub-account_info'>

                    <Spin indicator={antIcon} spinning={this.props.affiliates.inProcess}>

                        <div className='ta--flex rtl--row-reverse'>
                            <div className='ta--account-col'>
                                {commissions && Object.keys(commissions).map(key => {
                                    if (!(+key%2)) {
                                        return (
                                            <div className='ta--flex ta--justify-between' key={key}>
                                                <span>{commissions[key].CommissionName}:</span>
                                                <span className='ta--fw-b'>{commissions[key].Share}%</span>
                                            </div>
                                        )
                                    }
                                    return '';
                                })}
                            </div>

                            <div className='ta--account-col ta--mh-140'>
                                {commissions && Object.keys(commissions).map(key => {
                                    if (+key%2) {
                                        return (
                                            <div className='ta--flex ta--justify-between' key={key}>
                                                <span>{commissions[key].CommissionName}:</span>
                                                <span className='ta--fw-b'>{commissions[key].Share}%</span>
                                            </div>
                                        )
                                    }
                                    return '';
                                })}
                            </div>
                        </div>
                    </Spin>

                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        affiliates: state.affiliates
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
};

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Commissions))



// WEBPACK FOOTER //
// ./src/routes/subAffilate/Account/Commissions.js